import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetAuftragMutation, useGetHinweiseFuerAGMutation, useGetHistoriePublicMutation, useSpeicherAuftragMutation } from "../../api/AuftragAPI";
import { IAuftrag, IAuftragHinweisResponse, IAuftragHistorie } from "../../types/Types";
import { formatToEuroDate, formatToEuroDateTime } from "../../util/DateUtils";
import AuftragMessageComponent from "../chat/AuftragMessageComponent/AuftragMessageComponent";
import MapComponent, { ILocation } from "../MapComponent/MapComponent";
import UploadToServer from "../UploadComponent/UploadToServer";
import styles from "./auftragcustomerdetailcomponent.module.scss";
import AuftragFilesDownloadButtonComponent from "../buttons/AuftragFilesDownloadButtonComponent";

type ThisProps = {
  uid: string,
  onSpeichern: () => void,
}

/**
 * @author noone
 */
const AuftragCustomerDetailComponent: React.FC<ThisProps> = (props) => {

  const { t } = useTranslation();

  const [getAuftragHistoriePublic] = useGetHistoriePublicMutation();
  const [getAuftrag] = useGetAuftragMutation();
  const [speicherAuftragAPI] = useSpeicherAuftragMutation();
  const [getHinweise] = useGetHinweiseFuerAGMutation();

  const [auftrag, setAuftrag] = useState<IAuftrag>();
  const [historie, setHistorie] = useState<IAuftragHistorie[]>([]);
  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [hinweise, setHinweise] = useState<IAuftragHinweisResponse[]>([]);

  const lade = () => {

    getAuftrag(props.uid).unwrap()
      .then((data) => setAuftrag(data))
      .catch((error) => console.log(error))
      .finally(() => setLoaded(true))
      ;

    getAuftragHistoriePublic(props.uid).unwrap().then((data) => setHistorie(data));

    getHinweise(props.uid).unwrap().then((data) => {
      setHinweise(data);
    });
  }

  const changeit = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!props.uid) return;
    setAuftrag((prevData) => {
      if (!prevData) return prevData;
      return {
        ...prevData,
        [e.target.name]: e.target.value
      };
    });
  }

  const speichern = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    speicherAuftragAPI({
      uid: auftrag?.uid!!,
      art: auftrag?.art!!,
      spaetmesstermin: auftrag?.spaetmesstermin!!,
      vorname_endkunde: auftrag?.vorname_endkunde!!,
      name_endkunde: auftrag?.name_endkunde!!,
      strasse_lieferadresse: auftrag?.strasse_lieferadresse!!,
      hausnummer_lieferadresse: auftrag?.hausnummer_lieferadresse!!,
      postleitzahl_lieferadresse: auftrag?.postleitzahl_lieferadresse!!,
      stadt_lieferadresse: auftrag?.stadt_lieferadresse!!,
      land_lieferadresse: auftrag?.land_lieferadresse!!,
      besonderheiten: auftrag?.besonderheiten!!,
      messzeitpunkt: auftrag?.messzeitpunkt!!,
      telefon_lieferadresse: auftrag?.telefon_lieferadresse!!,
      email_lieferadresse: auftrag?.email_lieferadresse!!,
      mobil1_lieferadresse: auftrag?.mobil1_lieferadresse!!,
      mobil2_lieferadresse: auftrag?.mobil2_lieferadresse!!,
      ansprechpartner: auftrag?.name_ansprechpartner!!,
      kontakt_ansprechpartner: auftrag?.kontakt_ansprechpartner!!,
      email_ansprechpartner: auftrag?.email_ansprechpartner!!,
      auftragsnr_ag: auftrag?.auftragsnr_ag!!,
      lat: auftrag?.lat!!,
      lng: auftrag?.lng!!,
      auftraggeberUid: undefined,
      dauerInMinuten: auftrag?.dauerInMinuten!!,
    }).then(() => props.onSpeichern());

  }

  const setWith100PercentForInputMapField = () => {
    const interval = setInterval(() => {
      // finde das Element mit Klasse "autocomplete-control"
      const autocompleteControl = document.querySelector(".autocomplete-control");
      if (autocompleteControl && autocompleteControl.parentElement) {
        // setze style am Eltern-Element
        autocompleteControl.parentElement.style.width = "100%";
        autocompleteControl.parentElement.style.left = "0px";
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }

  const locationset = (location: ILocation) => {
    if (auftrag !== undefined) {
      setAuftrag((prevData) => {
        if (!prevData) return undefined; // Handle undefined case
        return {
          ...prevData,
          strasse_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'route')?.long_name || '',
          hausnummer_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'street_number')?.long_name || '',
          postleitzahl_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'postal_code')?.long_name || '',
          stadt_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'locality')?.long_name || '',
          land_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'country')?.long_name || '',
          lat: location.lat,
          lng: location.lng,
        };
      });
    }
  };


  useEffect(() => {
    window.scrollTo(0, 0);
    setWith100PercentForInputMapField();
    lade();
  }, []);

  return (
    <>

      <div className="form-group">
        {t('deTranslation.auftragDetails.art')}:
        <input readOnly={true} className='form-control' name="art" value={auftrag?.art} />
      </div>

      <div className="card" style={{ padding: "30px" }}>

        <AuftragFilesDownloadButtonComponent uidAuftrag={props.uid} />
        
        Lieferadresse:
        <p></p>
        <br />{auftrag?.vorname_endkunde} {auftrag?.name_endkunde}
        <br />{auftrag?.strasse_lieferadresse} {auftrag?.hausnummer_lieferadresse}
        <br />{auftrag?.postleitzahl_lieferadresse} {auftrag?.stadt_lieferadresse}
        <br />{auftrag?.land_lieferadresse}
        <p></p>

        <div style={{ height: '500px', width: '70%' }}>
          {auftrag &&
            <MapComponent onLocationSet={locationset} startLng={auftrag.lng} startLat={auftrag.lat} scrollZoom={false} />
          }
        </div>

        <br />Telefon: <input type="text" className="form-control" name="telefon_lieferadresse" value={auftrag?.telefon_lieferadresse} onChange={changeit} />
        <br />Mobil1: <input type="text" className="form-control" name="mobil1_lieferadresse" value={auftrag?.mobil1_lieferadresse} onChange={changeit} />
        <br />Mobil2: <input type="text" className="form-control" name="mobil2_lieferadresse" value={auftrag?.mobil2_lieferadresse} onChange={changeit} />
        <br />E-Mail: <input type="text" className="form-control" name="email_lieferadresse" value={auftrag?.email_lieferadresse} onChange={changeit} />
        <p></p>
        {(auftrag?.status === "NEU" || auftrag?.status === "IN_TERMINIERUNG" || auftrag?.status === "WIEDERVORLAGE") &&
          <button className='btn btn-primary' value="Speichern" onClick={speichern}><i className="bi bi-plus"></i> Speichern</button>
        }
      </div>

      {/*<div className="form-group">
                {t('deTranslation.auftragDetails.telefon_lieferadresse')}:
                <input readOnly={true} className='form-control' name="telefon_lieferadresse" value={auftrag?.telefon_lieferadresse} />
              </div>*/}
      <div className={styles.bottomHinweisGrid} >

        <div>
          <h4>Dateien</h4>
          <UploadToServer uid={props.uid} />
        </div>

        <div>

          <h4>Aktionen (neuste zuerst):</h4>

          <ul>
            {historie?.map((e, index) =>
              <li key={index}>{(e.datum !== null) ? formatToEuroDate(e.datum) : "--"} {e.text!!}</li>
            )}
          </ul>

        </div>

        <div>

          <h4>Hinweise</h4>

          {hinweise?.map((e, index) => <>
            <div key={e.uid} className="card">

              <div className="card-body">
                {e.text}
              </div>
              <div className="card-footer" style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ textAlign: "left" }}>Erstellt am: {formatToEuroDateTime(e.erstelltAm)}</div>
                <div style={{ textAlign: "right" }}>Erstellt von: {e.erstelltVon}</div>
              </div>

            </div>
          </>)}

        </div>

        <div>
          {auftrag &&
            <AuftragMessageComponent auftragUid={auftrag.uid} />
          }
        </div>
      </div>
    </>
  );

}

export default AuftragCustomerDetailComponent;